<template>
  <div class="focus">
    <div class="Tit">我的关注</div>
    <div class="content">
      <li v-for="(item,index) in info" :key="index">
        <router-link :to="{ path: '/teacherDetails', query: { id: item.id }  }" >
          <div class="img"><img :src="item.avatar" width="85" height="85" alt=""></div>
          <div class="name">{{item.name}}</div>
          <div class="con line-clamp-3">{{item.profile}}</div>
        </router-link>
      </li>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {}
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList () {
        this.$http.post('/apipx/Personal/myfocus', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .focus {
    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .content {
      overflow: hidden;

      li {
        width: 240px;
        border-radius: 15px;
        float: left;
        margin: 22px 22px 0 0;
        border: 1px solid #ededed;
        padding: 20px;

        &:nth-child(3n) {
          margin: 22px 0 0 0;
        }

        .img {
          width: 85px;
          height: 85px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto;
        }

        .name {
          font-size: 16px;
          text-align: center;
          margin: 10px auto 30px;
        }

        .con {
          line-height: 25px;
          height: 75px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/focus/focus.vue